import type { Theme } from './themeManager';
import themeManager from './themeManager'

// 默认亮色主题
export const lightTheme: Theme = {
  name: 'light',
  variables: {
    // 主要颜色
    'primary-color': 'rgba(24, 144, 255, 1)',
    'secondary-color': 'rgba(82, 196, 26, 1)',
    'accent-color': 'rgba(114, 46, 209, 1)',

    // 背景颜色
    'bg-color': 'rgba(255, 255, 255, 1)',
    'bg-color-secondary': 'rgba(245, 245, 245, 1)',

    // 文本颜色
    'text-color': 'rgba(51, 51, 51, 1)',
    'text-color-secondary': 'rgba(102, 102, 102, 1)',

    // 边框颜色
    'border-color': 'rgba(232, 232, 232, 1)',

    // 组件特定颜色
    'flow-bg-color': 'rgba(240, 242, 245, 1)',
    'node-bg-color': 'rgba(255, 255, 255, 1)',
    'node-border-color': 'rgba(217, 217, 217, 1)',
    'node-selected-border-color': 'rgba(24, 144, 255, 1)',
    'container-bg-color': 'rgba(250, 250, 250, 1)',
  }
};

// 暗色主题
export const darkTheme: Theme = {
  name: 'dark',
  variables: {

    // 公有变量 
    'Mflow-border-color': 'rgba(181, 181, 181, 0.2)',
    'Mflow-boder-hover-color': 'rgba(181, 181, 181, 0.5)',
    'Mflow-primary-color': 'rgba(9, 96, 189, 1)',
    'Mflow-primary-hover': 'rgba(9, 119, 230, 1)',
    'Mflow-primary-shadow-color': 'rgba(0, 0, 0, 0.1)',
    'Mflow-tip-text-color': 'rgba(158, 158, 157, 1)',
    // 滚动条样式
    'Mflow-scrollbar-bg': 'rgba(181, 181, 181, 0.2)',
    'Mflow-scrollbar-hover-bg': 'rgba(181, 181, 181, 0.5)',
    'Mflow-scrollbar-width': 8,
    'Mflow-scrollbar-radius': 4,
    'Mflow-scrollbar-height': 8,
    'Mflow-scrollbar-hover-height': 16,

    // 画布样式
    'Mflow-container-bg': 'rgba(27, 27, 27, 1)',
    'Mflow-bg-color': 'rgba(177, 177, 183, 1)',
    'Mflow-bg-gap': 25,
    'Mflow-line-color': 'rgba(177, 177, 183, 1)',
    'Mflow-line-width': 2,
    'Mflow-arrow-color': 'rgba(177, 177, 183, 1)',

    // 节点列表样式
    'Mflow-nodelist-bg': 'rgba(32, 32, 32, 1)',
    'Mflow-nodelist-text': 'rgba(255, 255, 255, 1)',
    'Mflow-nodelist-input-bg': 'rgba(46, 46, 46, 1)',
    'Mflow-nodelist-input-text': 'rgba(237, 237, 237, 1)',
    'Mflow-nodelist-item-bg': 'rgba(46, 46, 46, 1)',
    'Mflow-nodelist-item-hover': 'rgba(149, 158, 188, 0.4)',
    'Mflow-nodelist-title-color': 'rgba(237, 237, 237, 1)',

    // 节点样式
    'Mflow-node-bg': 'rgba(46, 47, 50, 1)',
    'Mflow-node-selected-shadow': 'rgba(251, 250, 250, 0.9)',
    'Mflow-node-header-color': 'rgba(255, 255, 255, 1)',
    'Mflow-node-header-hover': 'rgba(255, 255, 255, .3)',

    // 小地图样式
    'Mflow-minimap-bg': 'rgba(46, 47, 50, 1)',
    'Mflow-minimap-container-bg': 'rgba(117, 118, 119, 1)',
    'Mflow-minimap-node-color': 'rgba(8, 8, 8, 0.79)',

  }
};

// 注册默认主题并应用默认主题（优先使用本地保存的主题）
try {
  themeManager.registerTheme(lightTheme)
  themeManager.registerTheme(darkTheme)
  // 优先使用用户之前保存的主题
  themeManager.loadSavedTheme()
  // 若仍未应用任何主题，则默认切换到 dark
  if (!themeManager.getCurrentTheme()) {
    themeManager.switchTheme('dark')
  }
} catch (e) {
  // SSR 或非浏览器环境下跳过
}
